import type { ReactNode } from 'react';
import { DatabuilderJobPollingContext, store } from './context';

export function DatabuilderJobPollingProvider({
	children,
}: {
	children: ReactNode;
}) {
	return (
		<DatabuilderJobPollingContext.Provider value={store}>
			{children}
		</DatabuilderJobPollingContext.Provider>
	);
}
